import BaseApiClient from '@/app/model/api/response/baseApiClient'

class NewsBoardDetailApi extends BaseApiClient {
  public getDetail (id: string) {
    const path = '/v1/news-board/' + id
    const url = new URL(process.env.VUE_APP_API_URL + path)

    return super.doFetch(decodeURI(url.href), 'GET')
  }
}

export default new NewsBoardDetailApi()
